import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, combineLatest, EMPTY, NEVER, Observable, ObservedValueOf, of, OperatorFunction } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { APP_BASE_HREF } from '@angular/common';
import Url from 'url-parse';
import { EveReportingWidget } from '../components/widgets/widget.component';




@Injectable()
export class ControlWidgetService {
  constructor(
  ) { }

  public controlWidgets: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  addControlWidget(widget: any) {
    this.controlWidgets.next(this.controlWidgets.value.concat([widget]));
  }
  removeControlWidget(widget: any) {
    this.controlWidgets.next(this.controlWidgets.value.filter(w => w != widget));
  }
}


export interface EveReportingControlWidgetWidget extends EveReportingWidget {
  controlWidgetId: String,
  controlWidgetName?: String,
}
